import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	RouterStateSnapshot,
} from '@angular/router';
import { AppGuard } from '../../guard';
import { OfflineAuthService } from '../service';

@Injectable()
export class OfflineGuard extends AppGuard {
	constructor(
		private readonly offlineAuthService: OfflineAuthService,
		private readonly router: Router
	) {
		super();
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | Promise<boolean> {
		if (!this.offlineAuthService.isLoggedIn) {
			return this.router.navigate(['/']);
		}
		return true;
	}
}
